import { createVNode, render } from 'vue'
import { defineNuxtPlugin } from 'nuxt/app'
import AppToast from '~/components/common/AppToast.vue'
import type { AppToastFn } from '../types/toast'

let toastContainer: HTMLDivElement | null = null
let lastToastContext: 'default' | 'usercenter' = 'default'

const USER_CENTER_TOAST_CONTEXT = 'usercenter' as const
const TOAST_CONTAINER_DATASET = 'appToastContext'

const detectToastContext = (): 'default' | 'usercenter' => {
  const isUserCenter = document.getElementsByClassName('usercenter-maincontent').length > 0
  return isUserCenter ? USER_CENTER_TOAST_CONTEXT : 'default'
}

const ensureToastContainer = () => {
  // Mount toast at body level so fixed positioning always uses the viewport.
  if (!toastContainer || !toastContainer.isConnected) {
    toastContainer = document.createElement('div')
    toastContainer.dataset.appToast = 'true'
    toastContainer.dataset[TOAST_CONTAINER_DATASET] = 'default'
    toastContainer.style.position = 'fixed'
    toastContainer.style.inset = '0'
    toastContainer.style.zIndex = '4000'
    toastContainer.style.pointerEvents = 'none'
    document.body.appendChild(toastContainer)
  }

  lastToastContext = detectToastContext()
  toastContainer.dataset[TOAST_CONTAINER_DATASET] = lastToastContext

  return toastContainer
}

export default defineNuxtPlugin((nuxtApp) => {
  const toast: AppToastFn = (type, message, options = {}) => {
    const normalizedMessage = String(message ?? '').trim()
    if (!normalizedMessage) return

    const container = ensureToastContainer()
    const vnode = createVNode(AppToast, {
      ...options,
      key: Date.now(),
      type,
      message: normalizedMessage,
      context: lastToastContext,
      onClose: () => {
        render(null, container)
      },
    })

    render(vnode, container)
  }

  nuxtApp.vueApp.config.globalProperties.$toast = toast

  return {
    provide: {
      toast,
    },
  }
})
